<template>
  <div class="brand-list">
    <div class="swiper-button-prev"></div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="brandinfo in bannerList"
          v-if="brandinfo.image"
          @click="clickBrand(brandinfo)"
          :title="showmsg(brandinfo.id)"
        >
          <img :src="brandinfo.image" />
        </div>
      </div>
    </div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/swiper.min.css";
export default {
  data() {
    return {
      bannerList: {},
      initTime: 5
    };
  },
  props: ["brandId"],
  methods: {
    leftTime() {
      // this.initTime--;
      // console.log(this.initTime)
      // if(this.initTime==0){
      //     console.log("我设置了")
      //     this.galleryThumbs.slideTo(2, 50, false);
      // }
    },
    showmsg(id) {
      if (id > 5) {
        return "即将上新，敬请期待";
      }
    },
    getclasslist() {
      this.$api.index.getIndexBrand().then(res => {
        var bannerListTmp = res.data.datas;
        var initialSlide = bannerListTmp.findIndex(item => {
          if (item.id == this.brandId) {
            return true;
          }
        });
        if (initialSlide > -1 && bannerListTmp.length > 0) {
          var bannerListTmpq = bannerListTmp.slice(0, initialSlide);
          var bannerListTmpm = bannerListTmp.slice(initialSlide, 5);
          var bannerListTmph = bannerListTmp.slice(5, bannerListTmp.length);
          bannerListTmpm.push(...bannerListTmpq);
          bannerListTmpm.push(...bannerListTmph);
          this.bannerList = bannerListTmpm;
        }
        this.$nextTick(function() {
          this.getSwiper();
        });
      });
    },
    getSwiper() {
      this.galleryThumbs = new Swiper(".swiper-container", {
        spaceBetween: 20,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    },
    clickBrand(brandinfo) {
      this.$router.push({ name: "brand", params: { id: brandinfo.id } });
    }
  },
  watch: {
    brandId(val) {
      this.getclasslist();
    }
  },
  mounted() {
    this.getclasslist();
  }
};
</script>

<style scoped>
/**切换图 */
.brand-list {
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  height: 150px;
}
.brand-list .swiper-container {
  width: 1080px;
  margin-left: 60px;
}
.brand-list .swiper-container .swiper-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 15px;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  color: #2655ae;
}
.brand-list .swiper-container .swiper-slide {
  overflow: hidden;
  width: 190px;
  height: 124px;
  background-color: #fff;
  border-radius: 10px;
}
.brand-list .swiper-container .swiper-slide:last-child {
  margin-right: 30px;
}
.brand-list .swiper-container .swiper-slide:hover {
  width: 210px;
  height: 145px;
  margin-left: -10px;
  margin-right: 10px !important;
  border-radius: 10px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
}
/* .brand-list .swiper-container .swiper-slide-active{
        width:222px;
        height:145px;
    } */
.brand-list .swiper-container .swiper-slide li {
  width: 100%;
  height: 100%;
}
.brand-list .swiper-container .swiper-slide img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/brand/brandlist.vue